import { defineMessages } from 'react-intl-next';

const _default_1: {
	browseAgentsPillLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	browseAgentsPillLabel: {
		id: 'ai-mate.rovo-agent-components.browse-agents-pill.label',
		defaultMessage: 'Browse Agents',
		description: 'The label displayed on the browse agents pill',
	},
});
export default _default_1;
